import { ForwardRefRenderFunction, forwardRef, memo } from "react";
import { IInput } from "@/components/Input/types";
import { InputStyled } from "@/components/Input/styled";
import Image from "next/legacy/image";
import { Close, RedAlert } from "@/icons";
import { imageLoader } from "@/utils";

const FormInput: ForwardRefRenderFunction<HTMLInputElement, IInput> = (
    props,
    ref
) => {
    const {
        type,
        name,
        value,
        onChange,
        placeholder = " ",
        error = "",
        label,
        className = "",
        deleteButton = false,
        icon = false,
        iconColor = "",
        borderColor = "",
        borderValue = "",
        textColor = "",
        ...rest
    } = props;

    const deleteValue = () => {
        if (onChange) {
            const event = {
                target: {
                    name: name || "",
                    value: ""
                }
            } as React.ChangeEvent<HTMLInputElement>;
            onChange(event);
        }
    };


    return (
        <InputStyled
            className={`${className} ${error && "error-input"}`}
            id="smartlook-hide"
            data-sl="mask"
            iconColor={`${iconColor}`}
            borderColor={`${borderColor}`}
            textColor={`${textColor}`}
            borderValue={borderValue}
            {...rest}>
            <input
                className="text-input"
                id="smartlook-hide"
                data-sl="mask"
                type={type}
                placeholder={placeholder}
                name={name}
                value={value}
                onChange={onChange}
                ref={ref}
                {...rest} />
            {deleteButton &&
                (error ? (
                    <span>
                        <Image src={RedAlert} width={24} height={24} alt="Vodafone Ev İnterneti" loader={imageLoader} />
                    </span>
                ) : (
                    <span onClick={deleteValue}>
                        <Image src={Close} width={24} height={24} alt="Vodafone Ev İnterneti" loader={imageLoader} />
                    </span>
                ))}
            {icon && <div className="icon"></div>}
            <label className="text-label" id="smartlook-hide" data-sl="mask">{label}</label>
        </InputStyled>
    )
}
const Input = forwardRef(FormInput);

export default memo(Input);
